// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const ReportOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 16 18","focusable":"false"},"children":[{"tag":"path","attrs":{"d":"M11.06.25c.44 0 .87.18 1.18.49l3.19 3.19c.31.31.49.73.49 1.18v10.14a2.5 2.5 0 01-2.5 2.5H2.58a2.5 2.5 0 01-2.5-2.5V2.75a2.5 2.5 0 012.5-2.5h8.48zM10.5 1.5H2.58c-.66 0-1.2.52-1.24 1.18v12.57c0 .67.51 1.21 1.17 1.25h10.91c.66 0 1.2-.52 1.24-1.18V6.08h-2.91c-.69 0-1.25-.56-1.25-1.25V1.5zm2.92 8.08v.92c0 .1-.08.17-.17.17H2.75a.17.17 0 01-.17-.17v-.92c0-.09.08-.16.17-.16h10.5c.1 0 .17.07.17.16zM8 7.08V8c0 .1-.07.17-.17.17H2.75A.17.17 0 012.58 8v-.92c0-.09.08-.16.17-.16h5.08c.1 0 .17.07.17.16zm3.75-4.66v2.25c0 .09.07.16.17.16l2.23-.01a.17.17 0 00.11-.29L12.03 2.3a.17.17 0 00-.28.12z","fill":"currentColor"}}]},"name":"report","theme":"outlined"};

const ReportOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={ReportOutlinedSvg} />;
  ReportOutlined.displayName = 'ReportOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(ReportOutlined);
